import script from "./HoldTimeSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./HoldTimeSelector.vue?vue&type=script&setup=true&lang=ts"

import "./HoldTimeSelector.vue?vue&type=style&index=0&id=dcd776b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcd776b2"]])

export default __exports__